<template>
  <el-container class="admin-layout">
    <el-aside width="220px" class="admin-aside">
      <div class="brand">
        <img :src="brandLogo" alt="宸镜AI" class="brand-logo" />
      </div>
      <el-menu
        :default-active="$route.path"
        background-color="#1e3a5f"
        text-color="#bfcbd9"
        active-text-color="#f59e0b"
        router
        unique-opened
      >
        <admin-menu-item v-for="menu in adminMenus" :key="menu.id" :menu="menu" />
      </el-menu>
    </el-aside>
    <el-container class="admin-body">
      <el-header class="admin-header">
        <span class="admin-title">{{ pageTitle }}</span>
        <div class="admin-user">
          <el-button type="text" @click="$router.push('/hq/board')">代理商后台</el-button>
          <el-button type="text" :loading="forumLoading" @click="openForumAdmin">论坛管理</el-button>
          <span>{{ adminDisplayName }}</span>
          <el-button type="text" class="logout-btn" @click="handleLogout">退出</el-button>
        </div>
      </el-header>
      <el-main ref="main" class="admin-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AdminMenuItem from './AdminMenuItem.vue'
import { getForumAdminEntry } from '@/api/admin'
import { brandLogoUrl, adminDocumentTitle } from '@/utils/brand'

export default {
  name: 'AdminLayout',
  components: { AdminMenuItem },
  data() {
    return {
      forumLoading: false,
      brandLogo: brandLogoUrl('dark')
    }
  },
  computed: {
    ...mapGetters(['adminMenus', 'adminInfo']),
    adminDisplayName() {
      if (!this.adminInfo) return '管理员'
      return this.adminInfo.realName || this.adminInfo.username || '管理员'
    },
    pageTitle() {
      const fromRoute = this.$route.meta && this.$route.meta.menuName
      if (fromRoute) return fromRoute
      const matched = this.findMenuByPath(this.adminMenus, this.$route.path)
      return matched ? matched.menuName : '管理后台'
    }
  },
  watch: {
    pageTitle: {
      immediate: true,
      handler(title) {
        document.title = adminDocumentTitle(title)
      }
    },
    '$route.path'() {
      this.$nextTick(() => {
        const main = this.$refs.main
        const el = main && (main.$el || main)
        if (el) el.scrollTop = 0
      })
    }
  },
  methods: {
    ...mapActions(['adminLogout']),
    async openForumAdmin() {
      if (this.forumLoading) return
      this.forumLoading = true
      try {
        const result = await getForumAdminEntry()
        if (result && result.redirectUrl) {
          window.open(result.redirectUrl, '_blank')
        }
      } catch (e) {
        // 错误由 request 拦截器统一弹框
      } finally {
        this.forumLoading = false
      }
    },
    findMenuByPath(menus, path) {
      for (const menu of menus) {
        if (menu.path === path) return menu
        if (menu.children && menu.children.length) {
          const found = this.findMenuByPath(menu.children, path)
          if (found) return found
        }
      }
      return null
    },
    handleLogout() {
      this.adminLogout()
      this.$router.replace('/admin/login')
    }
  }
}
</script>

<style scoped>
.admin-layout {
  height: 100vh;
  overflow: hidden;
}
.admin-body {
  height: 100vh;
  min-height: 0;
  overflow: hidden;
}
.admin-aside {
  background: #1e3a5f;
  height: 100vh;
  overflow-y: auto;
}
.brand {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  box-sizing: border-box;
}
.brand-logo {
  display: block;
  height: 34px;
  width: auto;
  max-width: 100%;
  object-fit: contain;
}
.admin-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
  padding: 0 24px;
}
.admin-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}
.admin-user {
  display: flex;
  align-items: center;
  gap: 12px;
  color: #606266;
}
.logout-btn {
  color: #f56c6c;
}
.admin-main {
  background: #f5f7fa;
  min-height: 0;
  overflow-y: auto;
}
</style>

<style>
.admin-aside .el-menu {
  border-right: none;
}
</style>
